import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { MessageSquareHeart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

const API = process.env.REACT_APP_BACKEND_URL;
const QS = [
  { key: 'expected', q: 'What did you expect FBC to do for you?' },
  { key: 'if_not_listed', q: "What would you do if your project wasn't listed?" },
  { key: 'your_responsibility', q: 'What do you think remains your responsibility?' },
];
const NEW_USER_DAYS = 30;

// Four quick questions for recent sign-ups; only while an admin has switched it on.
export default function FirstVisitSurvey({ user }) {
  const [show, setShow] = useState(false);
  const [a, setA] = useState({ expected: '', if_not_listed: '', your_responsibility: '', would_invite: null });
  const [sending, setSending] = useState(false);
  useEffect(() => {
    if (!user || ['admin', 'developer'].includes(user.role)) return;
    const age = (Date.now() - new Date(user.created_at).getTime()) / 86400000;
    if (!(age <= NEW_USER_DAYS)) return;
    axios.get(`${API}/api/ethos/survey/status`).then((r) => setShow(r.data.enabled && !r.data.done)).catch(() => {});
  }, [user]);
  if (!show) return null;
  const send = async () => {
    setSending(true);
    try { await axios.post(`${API}/api/ethos/survey`, a); toast.success('Thank you. This helps us explain FBC better.'); setShow(false); }
    catch { toast.error('Could not send. Please try again.'); }
    finally { setSending(false); }
  };
  const skip = () => { setShow(false); axios.post(`${API}/api/ethos/survey/skip`).catch(() => {}); };
  return (
    <div className="container mx-auto px-4 mt-4 max-w-6xl" data-testid="first-visit-survey">
      <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 space-y-3">
        <p className="font-semibold flex items-center gap-2"><MessageSquareHeart className="h-4 w-4 text-primary" />Help us explain FBC better (1 minute)</p>
        <div className="grid md:grid-cols-3 gap-3">
          {QS.map((x) => (
            <label key={x.key} className="space-y-1">
              <span className="text-sm">{x.q}</span>
              <Textarea rows={2} value={a[x.key]} maxLength={1500} onChange={(e) => setA({ ...a, [x.key]: e.target.value })} data-testid={`survey-${x.key}`} />
            </label>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm mr-1">Would you invite another buyer from your project?</span>
          {['yes', 'maybe', 'no'].map((v) => (
            <Button key={v} size="sm" variant={a.would_invite === v ? 'default' : 'outline'} className="h-7 text-xs capitalize" onClick={() => setA({ ...a, would_invite: v })} data-testid={`survey-invite-${v}`}>{v}</Button>
          ))}
        </div>
        <div className="flex gap-2">
          <Button size="sm" onClick={send} disabled={sending || !(a.expected || a.if_not_listed || a.your_responsibility || a.would_invite)} data-testid="survey-submit">Send</Button>
          <Button size="sm" variant="ghost" onClick={skip} data-testid="survey-skip">Not now</Button>
        </div>
      </div>
    </div>
  );
}
